__turbopack_context__.v({
  "blockTwoColumnRichText": "BlockTwoColumnRichText-module-scss-module__LKCsMq__blockTwoColumnRichText",
  "column": "BlockTwoColumnRichText-module-scss-module__LKCsMq__column",
  "flushTop": "BlockTwoColumnRichText-module-scss-module__LKCsMq__flushTop",
  "image": "BlockTwoColumnRichText-module-scss-module__LKCsMq__image",
  "imageOnLeft": "BlockTwoColumnRichText-module-scss-module__LKCsMq__imageOnLeft",
  "imageWrap": "BlockTwoColumnRichText-module-scss-module__LKCsMq__imageWrap",
  "inner": "BlockTwoColumnRichText-module-scss-module__LKCsMq__inner",
  "richTextHeadingFour": "BlockTwoColumnRichText-module-scss-module__LKCsMq__richTextHeadingFour",
  "richTextParagraph": "BlockTwoColumnRichText-module-scss-module__LKCsMq__richTextParagraph",
  "whiteBackground": "BlockTwoColumnRichText-module-scss-module__LKCsMq__whiteBackground",
});
